module.exports = __webpack_public_path__ + "static/media/pin-light-viajes.13b8e3c2.png";